import CollapseBlock from '../../lib/collapse.js'
new CollapseBlock({ wrappers: document.querySelectorAll('.acv-collapse--wrapper') })